import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router-dom";
import portfolio from "../images/Works2.png";
import { IoNavigate } from "react-icons/io5";
function PortfolioHome() {
  const navto = useNavigate();
  const portfoliopage = () => {
    navto("/portfolio");
  };
  // onscrollanimation start
  const anime1 = {
    visible: {
      opacity: 1,
      x: 0,
      transition: { ease: "easeInOut", duration: 0.9 },
    },
    hidden: { opacity: 0, x: -100 },
  };
  const anime2 = {
    visible: {
      opacity: 1,
      x: 0,
      transition: { ease: "easeInOut", duration: 0.9 },
    },
    hidden: { opacity: 0, x: 100 },
  };

  const control = useAnimation();
  const [ref, inView] = useInView();
  useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);
  // onscrollanimation end
  return (
    <>
      <motion.div className="col-lg-6 col-md-12 col-sm-12" ref={ref}
        variants={anime1}
        initial="hidden"
        animate={control}>
        <div className="inner-sec">
          <h2 className="sec-head">Portfolio</h2>
          <p className="sec-para">
            Over the past year, I've been working on developing totally unique
            websites and online applications. Each of these websites and
            web applications has distinctive features and designs that set it apart
            from the competition.
          </p>
          <motion.button
            className="sec-btn btn "
            initial={{ opacity: 0.6 }}
            whileHover={{
              scale: 1.1,
              transition: { duration: 1 },
            }}
            whileTap={{ scale: 0.9 }}
            whileInView={{ opacity: 1 }} onClick={portfoliopage}>
            Know More <span className="ms-2"><IoNavigate /></span>
          </motion.button>
        </div>
      </motion.div>
      <motion.div className="col-lg-6 col-md-12 col-sm-12 text-center" ref={ref}
        variants={anime2}
        initial="hidden"
        animate={control}>
        <img src={portfolio} alt="works" className="sec-img-w" />
      </motion.div>
    </>
  );
}

export default PortfolioHome;
